import './BLCLogo.scss'

import blcLogo from 'assets/images/logo/partners/blc.svg'
import fluroLogo from 'assets/images/logo/fluro-logo.svg'

const BlueLightCardLogo = (): JSX.Element => {
  return (
    <div className="blc-logo-wrapper">
      <a href="https://www.bluelightcard.co.uk/" title="BLC homepage" data-test="logo-cta">
        <img src={blcLogo} className="blc-logo" alt="BLC Logo" data-test="blc-logo" />
      </a>
      <div className="powered-by">
        <span className="powered-text">Powered by</span>
        <img src={fluroLogo} className="fluro-powered-logo" alt="Fluro Logo" data-test="fluro-logo" />
      </div>
    </div>
  )
}

export default BlueLightCardLogo
